import {Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit} from '@angular/core';
import { DialogsService, PermisosService } from '../../../../services';
import { trigger, state, style, animate, transition} from '@angular/animations';

@Component({
  selector: 'app-action',
  templateUrl: './action.component.html',
  styleUrls: ['./action.component.scss'],
})
export class ActionComponent implements OnInit, AfterViewInit {

  actionItem: any = null;
  selected = false;
  childs = { DirectChilds: [], IndirectChilds: [] };
  expanded = true;
  // childsPixelSize = 0;

  initial = true;

  // @ViewChild('childsContainer') childsContainer: ElementRef;

  @Input()
  set Item(action: any) {
    this.actionItem = action;
    this.selected = this.actionItem.selected;
  }

  @Input()
  set ChildItems(childs: any) {
    this.childs = childs;
    // this.childsPixelSize = [...this.childs.DirectChilds, ...this.childs.IndirectChilds].length * 48;
  }

  @Input() disabled = false;

  constructor(private dialogsService: DialogsService,
              private permisosService: PermisosService) {
    this.permisosService.actionsToEdit.subscribe(x => {
      if (x && this.actionItem) {
        const id = x.findIndex(y => y.Id === this.actionItem.Id);
        if (x[id].selected !== this.selected) {
          this.selected = x[id].selected;
        }
      }
    });
  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    // if (this.childsContainer) {
    //   this.childsContainer.nativeElement.style.height = this.childsPixelSize.toString() + 'px';
    // }
  }

  onUpdateCkeckChanged(e) {
    this.selected = e.checked;
    this.permisosService.onActionChanged(this.actionItem.Id, this.selected);
  }

  getChildItems(action) {
    return this.permisosService.getDirectChilds(action);
  }

  toggleExpand() {
    this.expanded = !this.expanded;
    // const el = this.childsContainer.nativeElement;
    //
    // const prevHeight = el.style.height;
    // // el.style.height = 'auto';
    // const newHeight = this.expanded ? this.childsPixelSize.toString() + 'px' : '0px';
    // el.style.height = prevHeight;
    //
    // setTimeout(() => {
    //   el.style.height = newHeight;
    // }, 50);

  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/permisos-detail/action/action.component.ts